import _ from 'lodash'
export default _.toPath
